import { RandomGenerator } from "../test-utils";
var QueryResultSourceBuilder = /** @class */ (function () {
    function QueryResultSourceBuilder() {
        this.queryResultSource = {
            url: 'https://support.wix.com/article/velo-enabling-custom-site-registration',
            product: 'Velo',
            distance: 0.30388182401657104,
            articleId: RandomGenerator.id(),
            articleTitle: 'Velo: Enabling Custom Site Registration',
            articleType: 'Article',
            score: 90,
            answer: '"To enable custom site registration using Velo forms, you need to add a lightbox to your site and create a custom registration form in the lightbox using Velo. Then, you need to click Pages on the left side of the Editor, click Signup & Login, click Member Signup Form, and select Velo Form from the drop-down menu. Note that Dev Mode must be turned on for this option to be available. Finally, choose the lightbox from the What does it link to? drop-down menu and enable the Only allow backend calls for Signup and Login APIs setting in Advanced Settings. "',
        };
    }
    QueryResultSourceBuilder.prototype.withUrl = function (url) {
        this.queryResultSource.url = url;
        return this;
    };
    QueryResultSourceBuilder.prototype.withProduct = function (product) {
        this.queryResultSource.product = product;
        return this;
    };
    QueryResultSourceBuilder.prototype.withDistance = function (distance) {
        this.queryResultSource.distance = distance;
        return this;
    };
    QueryResultSourceBuilder.prototype.withArticleTitle = function (articleTitle) {
        this.queryResultSource.articleTitle = articleTitle;
        return this;
    };
    QueryResultSourceBuilder.prototype.withArticleType = function (articleType) {
        this.queryResultSource.articleType = articleType;
        return this;
    };
    QueryResultSourceBuilder.prototype.withScore = function (score) {
        this.queryResultSource.score = score;
        return this;
    };
    QueryResultSourceBuilder.prototype.withAnswer = function (answer) {
        this.queryResultSource.answer = answer;
        return this;
    };
    QueryResultSourceBuilder.prototype.withArticleId = function (articleId) {
        this.queryResultSource.articleId = articleId;
        return this;
    };
    QueryResultSourceBuilder.prototype.withDataSourceDocType = function (dataSourceDocType) {
        this.queryResultSource.dataSourceDocType = dataSourceDocType;
        return this;
    };
    QueryResultSourceBuilder.prototype.build = function () {
        return this.queryResultSource;
    };
    return QueryResultSourceBuilder;
}());
export { QueryResultSourceBuilder };
//# sourceMappingURL=query-result-source.builder.js.map